<script>
/**
 * Descripción: Pantalla Instance By User Filtro
 *
 * @displayName InstanceByUserFilterViewComponent
 */

import BaseNotificationsHelper from '@/helpers/BaseNotificationsHelper.js';

const BaseServerDataTable = () =>
  import('@/components/core/grids/BaseServerDataTable.vue');

export default {
  name: 'InstanceByUserFilterViewComponent',

  components: {
    BaseServerDataTable
  },

  props: {
    /**
     * Enviar información adicional al servidor
     */
    extraParams: {
      type: Object,
      default: undefined
    },

    /**
     * Función Nuevo
     * Default undefined
     */
    fnNew: {
      type: Function,
      default: undefined
    },

    /**
     * Función Eliminar
     * Default undefined
     */
    fnDelete: {
      type: Function,
      default: undefined
    }
  },

  computed: {
    /**
     * Configuracion BaseServerDataTable
     */
    setting() {
      return {
        controller: 'InstanceByUser',
        method: this.extraParams ? 'Filter' : 'Grid',
        columns: [
          {
            text: 'Instancia',
            align: 'start',
            value: 'instanceName',
            show: true
          },
          {
            text: 'URL',
            align: 'start',
            value: 'instanceUrl',
            show: true
          },
          {
            text: 'Aplicación',
            align: 'start',
            value: 'applicationName',
            show: true
          },
          {
            text: 'Versión',
            align: 'start',
            value: 'currentVersion',
            show: false
          },
          {
            text: 'Status',
            align: 'start',
            value: 'status',
            show: false
          }
        ],
        key: 'instanceId',
        singleSelect: this.extraParams ? false : true
      };
    }
  },

  methods: {
    fnDoubleClick(params) {
      if (
        // eslint-disable-next-line no-useless-escape
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
          params.selected.instanceUrl
        )
      ) {
        window.open(params.selected.instanceUrl, '_blank');
      } else {
        BaseNotificationsHelper.Message(true, 'URL inválida');
      }
    },

    $_refresh() {
      this.$refs.GridFilter.$_ParamsToAPI();
      this.$refs.GridFilter.$data.selected = [];
    }
  }
};
</script>

<template>
  <div>
    <!-- @BaseServerDataTable -->
    <BaseServerDataTable
      :setting="setting"
      :extraParams="extraParams"
      :fnDoubleClick="fnDoubleClick"
      :fnNew="fnNew"
      :fnDelete="fnDelete"
      ref="GridFilter"
    />
  </div>
</template>
